@if (form) {
<form [formGroup]="form" (ngSubmit)="submit()" class="container mt-3">
    <div formGroupName="quote">
        @let quoteControls = form.controls.quote.controls;

        <dai-form-group for="quote-fob" label="FOB" [controller]="quoteControls['fob']">
            <input #inputRef id="quote-fob" formControlName="fob" />
        </dai-form-group>

        <dai-form-group for="quote-material-eta" label="Material ETA" [controller]="quoteControls['materialETA']">

            <div class="input-group">
                <input placeholder="yyyy-mm-dd" formControlName="materialETA" #inputRef id="quote-material-eta"
                    ngbDatepicker
                    [minDate]="{year: todayDate.getFullYear(), month: todayDate.getMonth() + 1, day: todayDate.getDate()}"
                    [autoClose]="true" #d="ngbDatepicker" (focus)="d.open()" (dateSelect)="d.close()" />
            </div>
        </dai-form-group>

        <dai-form-group for="quote-shipping" label="Shipping" [controller]="quoteControls['shipping']">
            <dai-currency-input #inputRef id="quote-shipping" formControlName="shipping"></dai-currency-input>
        </dai-form-group>

        <dai-form-group for="quote-rollup-shipping" label="Rollup Shipping"
            [controller]="quoteControls['rollupShipping']">
            <input #inputRef type="checkbox" id="quote-rollup-shipping" formControlName="rollupShipping" />
        </dai-form-group>

        <dai-form-group for="quote-shipping-tax" label="Shipping Sales Tax"
            [controller]="quoteControls['shippingSalesTax']">
            <input #inputRef type="checkbox" id="quote-shipping-tax" formControlName="shippingSalesTax" />
        </dai-form-group>

        <dai-form-group for="quote-discount" label="Discount" [controller]="quoteControls['discount']">
            <dai-currency-input #inputRef id="quote-discount" formControlName="discount"></dai-currency-input>
        </dai-form-group>

        <dai-form-group for="quote-discount-reason" label="Discount Reason"
            [controller]="quoteControls['discountReason']">
            <input #inputRef id="quote-discount-reason" formControlName="discountReason" />
        </dai-form-group>

        <dai-form-group for="quote-sales-tax" label="Sales Tax (%)" [controller]="quoteControls['salesTaxPercent']">
            <input #inputRef id="quote-sales-tax" formControlName="salesTaxPercent" />
        </dai-form-group>

        @if (hasHiddenMarkup) {
        <dai-form-group for="quote-hidden-markup" label="Hidden Markup (%)"
            [controller]="quoteControls['hiddenMarkup']">
            <input #inputRef id="quote-hidden-markup" formControlName="hiddenMarkup" readonly />
        </dai-form-group>
        }
    </div>

    @if (isQuickQuote) {
    <!-- Customer Info -->
    <div formGroupName="quickQuote">
        <fieldset formGroupName="customer">
            @let controlsCustomer =
            form.controls.quickQuote.controls.customer.controls;
            <legend>Customer</legend>

            <dai-form-group for="customer-name" label="Company Name" [controller]="controlsCustomer.name">
                <input #inputRef id="customer-name" formControlName="name" />
            </dai-form-group>

            <dai-form-group for="customer-poc-name" label="Point of Contact Name" [controller]="controlsCustomer.pointOfContactName">
                <input #inputRef id="customer-poc-name" formControlName="pointOfContactName" />
            </dai-form-group>

            <dai-form-group for="customer-poc-title" label="Point of Contact Title" [controller]="controlsCustomer.pointOfContactTitle">
                <input #inputRef id="customer-poc-title" formControlName="pointOfContactTitle" />
            </dai-form-group>

            <dai-form-group for="customer-address1" label="Address Line 1" [controller]="controlsCustomer.addressLine1">
                <input #inputRef id="customer-address1" formControlName="addressLine1" />
            </dai-form-group>

            <dai-form-group for="customer-address2" label="Address Line 2" [controller]="controlsCustomer.addressLine2">
                <input #inputRef id="customer-address2" formControlName="addressLine2" />
            </dai-form-group>

            <dai-form-group for="customer-city" label="City" [controller]="controlsCustomer.city">
                <input #inputRef id="customer-city" formControlName="city" />
            </dai-form-group>

            <dai-form-group for="customer-state" label="State" [controller]="controlsCustomer.state">
                <input #inputRef id="customer-state" formControlName="state" />
            </dai-form-group>

            <dai-form-group for="customer-zip" label="Zip Code" [controller]="controlsCustomer.zip">
                <input #inputRef id="customer-zip" formControlName="zip" />
            </dai-form-group>

            <dai-form-group for="customer-phone" label="Phone" [controller]="controlsCustomer.phone">
                <input #inputRef id="customer-phone" formControlName="phone" />
            </dai-form-group>

            <dai-form-group for="customer-email" label="Email" [controller]="controlsCustomer.email">
                <input #inputRef id="customer-email" type="email" formControlName="email" />
            </dai-form-group>
        </fieldset>


        <dai-form-group for="useBillingForShipping" label="Use Billing Address for Shipping">
            <input #inputRef id="useBillingForShipping" type="checkbox" formControlName="useBillingForShipping" />
        </dai-form-group>

        <fieldset formGroupName="shippingAddress"
            [disabled]="form.controls.quickQuote.controls.useBillingForShipping.value">
            @let controlsShipping = form.controls.quickQuote.controls.shippingAddress.controls;
            <legend>Shipping Address</legend>

            <dai-form-group for="shipping-name" label="Shipping Name" [controller]="controlsShipping.name">
                <input #inputRef id="shipping-name" formControlName="name" />
            </dai-form-group>

            <dai-form-group for="shipping-address1" label="Address Line 1" [controller]="controlsShipping.addressLine1">
                <input #inputRef id="shipping-address1" formControlName="addressLine1" />
            </dai-form-group>

            <dai-form-group for="shipping-address2" label="Address Line 2" [controller]="controlsShipping.addressLine2">
                <input #inputRef id="shipping-address2" formControlName="addressLine2" />
            </dai-form-group>

            <dai-form-group for="shipping-city" label="City" [controller]="controlsShipping.city">
                <input #inputRef id="shipping-city" formControlName="city" />
            </dai-form-group>

            <dai-form-group for="shipping-state" label="State" [controller]="controlsShipping.state">
                <input #inputRef id="shipping-state" formControlName="state" />
            </dai-form-group>

            <dai-form-group for="shipping-zip" label="Zip Code" [controller]="controlsShipping.zip">
                <input #inputRef id="shipping-zip" formControlName="zip" />
            </dai-form-group>
        </fieldset>


        <!-- Sales Representative Info -->
        <fieldset formGroupName="salesRepresentative">
            @let controlsSales =
            form.controls.quickQuote.controls.salesRepresentative.controls;
            <legend>Sales Representative</legend>

            <dai-form-group for="sales-name" label="Name" [controller]="controlsSales.name">
                <input #inputRef id="sales-name" formControlName="name" />
            </dai-form-group>

            <dai-form-group for="sales-title" label="Title" [controller]="controlsSales.title">
                <input #inputRef id="sales-title" formControlName="title" />
            </dai-form-group>

            <dai-form-group for="sales-phone" label="Phone Number" [controller]="controlsSales.phoneNumber">
                <input #inputRef id="sales-phone" formControlName="phoneNumber" />
            </dai-form-group>

            <dai-form-group for="sales-email" label="Email" [controller]="controlsSales.email">
                <input #inputRef id="sales-email" type="email" formControlName="email" />
            </dai-form-group>
        </fieldset>
    </div>
    }

    <!-- Submit -->
    <div class="mt-4 row">
        <button class="col-12 col-md-2 offset-md-2 btn btn-primary" type="submit"
            [disabled]="form.invalid">Submit</button>
    </div>
</form>
}
@else {
<app-loading></app-loading>
}